import { TbRectangleVertical } from "react-icons/tb";

const RedCardEvent = ({ playerNameAndTime }) => {
  return (
    <>
      <div className="flex items-center w-32 sm:w-40 space-x-1 mb-1 justify-start">
        <span>
          <TbRectangleVertical color="red" fill="red" />
        </span>
        <span className="text-white text-[10px] sm:text-xs truncate text-ellipsis">
          {playerNameAndTime}
        </span>
      </div>
    </>
  );
};

export default RedCardEvent;
